// src/components/SEO.js
import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, canonical }) {
  const siteName = "Eluvent – AI Tutor for CBSE & ICSE";
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const desc = description || "Get instant answers, practice with previous year board questions, and connect with expert teachers.";
  const url = canonical || "https://eluvent.com";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  );
}